var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateIcn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.883 9.45L6.167 8.667L7.884 7.884L8.667 6.167L9.45 7.884L11.167 8.667L9.45 9.45L8.667 11.167L7.883 9.45ZM8.666 19.5L9.449 17.783L11.166 17L9.45 16.217L8.667 14.5L7.883 16.217L6.166 17L7.883 17.783L8.666 19.5ZM5.642 12.309L4.5 12.834L5.642 13.359L6.167 14.501L6.692 13.359L7.834 12.834L6.692 12.309L6.167 11.167L5.642 12.309ZM12 12.001C12.0378 9.48727 13.0684 7.09054 14.867 5.334H12V3.667H17.833V9.5H16.167V6.4C15.4014 7.1223 14.7863 7.989 14.3573 8.95012C13.9282 9.91124 13.6936 10.9478 13.667 12C13.7023 13.3628 14.109 14.69 14.8434 15.8385C15.5777 16.987 16.6118 17.9132 17.834 18.517V20.334C16.1468 19.677 14.6921 18.5347 13.6537 17.0513C12.6153 15.568 12.0399 13.8112 12 12.001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateIcn);
export default __webpack_public_path__ + "static/media/generate-icn.1431fb44565807d8ab0dd4f464ea0906.svg";
export { ForwardRef as ReactComponent };